import { defineComponent as r, openBlock as o, createBlock as n, unref as c, mergeProps as l, withCtx as p, createElementVNode as m } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const k = /* @__PURE__ */ r({
  name: "IconBackMarketAvatar",
  __name: "IconBackMarketAvatar",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (i, e) => (o(), n(c(s), l(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        m("path", { d: "M13.18 18.957H9.038a.5.5 0 0 1-.36-.153L2.053 12.16a.25.25 0 0 1 0-.304L8.679 5.21a.5.5 0 0 1 .359-.153h4.142c.11 0 .165.139.096.222l-6.558 6.576a.22.22 0 0 0 0 .304l6.558 6.576c.083.083.028.221-.096.221m2.222-6.798 6.558 6.576c.083.083.028.221-.083.221h-4.142a.5.5 0 0 1-.358-.152l-6.627-6.659a.22.22 0 0 1 0-.304l6.627-6.645a.5.5 0 0 1 .358-.153h4.142c.11 0 .166.139.083.222l-6.558 6.576c-.083.097-.083.235 0 .318" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  k as default
};
